import React from 'react';
import { Link, Box } from '@miro-site/core';
import styled from 'styled-components';
import theme from './theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FooterLinksContainer = styled(Box).attrs({
  $styles: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: ['center', 'center', undefined],
    flex: ['0 0 100%', '0 0 100%', null]
  },
  $mt: [20, 20, null]
}).withConfig({
  displayName: "FooterLinks__FooterLinksContainer",
  componentId: "sc-1rsn5ej-0"
})([""]);
var Copyright = styled(Box).attrs({
  $styles: {
    fontSize: theme.footer.links.bottom.fontSize,
    lineHeight: theme.footer.links.bottom.lineHeight,
    color: theme.colors.primaryWhite
  },
  $mr: theme.footer.copyright.margin.right
}).withConfig({
  displayName: "FooterLinks__Copyright",
  componentId: "sc-1rsn5ej-1"
})([""]);
var CopyrightLink = styled(Link).withConfig({
  displayName: "FooterLinks__CopyrightLink",
  componentId: "sc-1rsn5ej-2"
})(["", ""], function (props) {
  return props.theme.normalizeStyles(theme.footer.links.bottom);
});
var FooterLink = styled(Link).attrs({
  $mr: theme.footer.copyrightLink.margin.right
}).withConfig({
  displayName: "FooterLinks__FooterLink",
  componentId: "sc-1rsn5ej-3"
})(["", " &:last-child{margin-right:0;}"], function (props) {
  return props.theme.normalizeStyles(theme.footer.links.bottom);
});

var FooterLinks = function FooterLinks(props) {
  var links = props.links;
  var year = new Date().getFullYear();
  return /*#__PURE__*/_jsxs(FooterLinksContainer, {
    children: [/*#__PURE__*/_jsxs(Copyright, {
      children: ["\xA9 ", year, ' ', /*#__PURE__*/_jsx(CopyrightLink, {
        href: "https://miro.com/",
        $color: "white",
        $size: "medium",
        children: "Miro"
      })]
    }), links.map(function (link, index) {
      return /*#__PURE__*/_jsx(FooterLink, {
        href: link.path,
        $color: "white",
        children: link.title
      }, index);
    })]
  });
};

export default FooterLinks;